'use client';

import { ReactNode, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n, { initI18nextClient } from '@/i18n/client';

interface TranslationProviderProps {
  children: ReactNode;
  lng: string;
}

export default function TranslationProvider({ children, lng }: TranslationProviderProps) {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    initI18nextClient(lng);
    setIsInitialized(true);
  }, [lng]);

  useEffect(() => {
    if (isInitialized && i18n.language !== lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng, isInitialized]);

  if (!isInitialized) {
    return null;
  }

  return (
    <I18nextProvider i18n={i18n}>
      {children}
    </I18nextProvider>
  );
}
